export default {
  chatBotPopup: false,
  distributeCoursePopup: false,
  editorPopup: false,
  filterPopup: false,
  searchPopup: false,
  addCustomCoursePopup: false,
};
